import { createWebHistory, createRouter } from "vue-router";
import axios from 'axios';
import Body from '../components/body';
import { getTenantDomainFromHost } from '../utils/domain';

import Login from '../auth/Login.vue';
import RecoverPassword from '../auth/RecoverPassword.vue';
import NewPassword from '../auth/NewPassword.vue';
import Home from '../pages/core/Home.vue';
import Customers from '../pages/customers/Customers.vue';
import CustomerDetail from '../pages/customers/CustomerDetail.vue';
import Suppliers from '../pages/suppliers/Suppliers.vue';
import SupplierDetail from '../pages/suppliers/SupplierDetail.vue';
import Sales from '../pages/sales/Sales.vue';
import Expenses from '../pages/expenses/Expenses.vue';
import Fees from '../pages/expenses/Fees.vue';
import Invoices from '../pages/invoices/Invoices.vue';
import SimpleNotes from '../pages/simple-notes/SimpleNotes.vue';
import SimpleNoteCreate from '../pages/simple-notes/SimpleNoteCreate.vue';
import SimpleNoteDetail from '../pages/simple-notes/SimpleNoteDetail.vue';
import PaymentReceipts from '../pages/payments/PaymentReceipts.vue';
import PaymentReceiptCreate from '../pages/payments/PaymentReceiptCreate.vue';
import PaymentReceiptDetail from '../pages/payments/PaymentReceiptDetail.vue';
import ExpensesPayments from '../pages/expenses-payments/ExpensesPayments.vue';
import ExpenseReceiptCreate from '../pages/expenses-payments/ExpenseReceiptCreate.vue';
import ExpenseReceiptDetail from '../pages/expenses-payments/ExpenseReceiptDetail.vue';
import InvoiceCreate from '../pages/invoices/InvoiceCreate.vue';
import InvoiceDetail from '../pages/invoices/InvoiceDetail.vue';
import SaleDetail from '../pages/sales/SaleDetail.vue';
import SalesFlatRates from '../pages/sales/SalesFlatRates.vue';
import SalesMultiCustomer from '../pages/sales/SalesMultiCustomer.vue';
import ReportsSales from '../pages/reports/ReportsSales.vue';
import ReportsIncomesReceivables from '../pages/reports/ReportsIncomesReceivables.vue';
import ReportsInvoices from '../pages/reports/ReportsInvoices.vue';
import ImportsHistory from '../pages/settings/ImportsHistory.vue';
import ExportFormats from '../pages/settings/ExportFormats.vue';
import Financial from '../pages/financial/Financial.vue';
import FinancialAccountDetail from '../pages/financial/FinancialAccountDetail.vue';

import NotFound from '../pages/error/404.vue'
import {
  ACCESS_PATCH_ROUTE_FALLBACK,
  isRouteAllowedForScopedAccessPatch,
  isScopedAccessPatchUser,
} from '../utils/scopedAccessPatch';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'Iniciar Sesión - Orderly',
    }
  },

  {
    path: '/recover-password',
    name: 'recoverPassword',
    component: RecoverPassword,
    meta: {
      title: 'Recuperar Cuenta - Orderly',
    }
  },
  {
    path: '/new-password',
    name: 'newPassword',
    component: NewPassword,
    meta: {
      title: 'Recuperar Cuenta - Orderly',
    }
  },
  {
    path: '/',
    component: Body,
    children: [
      {
        path: '', 
        name: 'home',
        component: Home,
        meta: {
          title: 'Bienvenido - Orderly.com',
        }
      },
      {
        path: 'customers',
        name: 'customers',
        component: Customers,
        meta: {
          title: 'Clientes - Orderly.com',
        }
      },
      {
        path: 'customers/:customerId',
        name: 'customerDetail',
        component: CustomerDetail,
        meta: {
          title: 'Detalle de cliente - Orderly.com',
        }
      },
      {
        path: 'suppliers',
        name: 'suppliers',
        component: Suppliers,
        meta: {
          title: 'Proveedores - Orderly.com',
        }
      },
      {
        path: 'suppliers/:supplierId',
        name: 'supplierDetail',
        component: SupplierDetail,
        meta: {
          title: 'Detalle de proveedor - Orderly.com',
        }
      },
      {
        path: 'sales',
        name: 'sales',
        component: Sales,
        meta: {
          title: 'Negocios - Orderly.com',
        }
      },
      {
        path: 'expenses',
        name: 'expenses',
        component: Expenses,
        meta: {
          title: 'Gastos - Orderly.com',
        }
      },
      {
        path: 'fees',
        name: 'fees',
        component: Fees,
        meta: {
          title: 'Comisiones - Orderly.com',
        }
      },
      {
        path: 'invoices',
        name: 'invoices',
        component: Invoices,
        meta: {
          title: 'Facturacion - Orderly.com',
        }
      },
      {
        path: 'simple-notes',
        name: 'simpleNotes',
        component: SimpleNotes,
        meta: {
          title: 'Notas simples - Orderly.com',
        }
      },
      {
        path: 'simple-notes/new',
        name: 'simpleNoteCreate',
        component: SimpleNoteCreate,
        meta: {
          title: 'Nueva nota simple - Orderly.com',
        }
      },
      {
        path: 'simple-notes/:simpleNoteId',
        name: 'simpleNoteDetail',
        component: SimpleNoteDetail,
        meta: {
          title: 'Detalle nota simple - Orderly.com',
        }
      },
      {
        path: 'incomes-payments',
        name: 'paymentReceipts',
        component: PaymentReceipts,
        meta: {
          title: 'Pagos - Orderly.com',
        }
      },
      {
        path: 'incomes-payments/new',
        name: 'paymentReceiptCreate',
        component: PaymentReceiptCreate,
        meta: {
          title: 'Nuevo pago - Orderly.com',
        }
      },
      {
        path: 'incomes-payments/:paymentReceiptId',
        name: 'paymentReceiptDetail',
        component: PaymentReceiptDetail,
        meta: {
          title: 'Detalle de pago - Orderly.com',
        }
      },
      {
        path: 'expenses-payments',
        name: 'expenseReceipts',
        component: ExpensesPayments,
        meta: {
          title: 'Pagos de egresos - Orderly.com',
        }
      },
      {
        path: 'expenses-payments/new',
        name: 'expenseReceiptCreate',
        component: ExpenseReceiptCreate,
        meta: {
          title: 'Nuevo pago de egresos - Orderly.com',
        }
      },
      {
        path: 'expenses-payments/:expenseReceiptId',
        name: 'expenseReceiptDetail',
        component: ExpenseReceiptDetail,
        meta: {
          title: 'Detalle de pago de egresos - Orderly.com',
        }
      },
      {
        path: 'invoices/new',
        name: 'invoiceCreate',
        component: InvoiceCreate,
        meta: {
          title: 'Nueva factura - Orderly.com',
        }
      },
      {
        path: 'invoices/:invoiceId',
        name: 'invoiceDetail',
        component: InvoiceDetail,
        meta: {
          title: 'Detalle de factura - Orderly.com',
        }
      },
      {
        path: 'sales/:saleId',
        name: 'saleDetail',
        component: SaleDetail,
        meta: {
          title: 'Detalle de negocio - Orderly.com',
        }
      },
      {
        path: 'sales/igualas',
        name: 'salesFlatRates',
        component: SalesFlatRates,
        meta: {
          title: 'Igualas - Orderly.com',
        }
      },
      {
        path: 'sales/multicliente',
        name: 'salesMultiCustomer',
        component: SalesMultiCustomer,
        meta: {
          title: 'Multicliente - Orderly.com',
        }
      },
      {
        path: 'reports',
        redirect: { name: 'reportsSales' },
      },
      {
        path: 'financial',
        name: 'financial',
        component: Financial,
        meta: {
          title: 'Financiero - Orderly.com',
        }
      },
      {
        path: 'financial/accounts/:financialAccountId',
        name: 'financialAccountDetail',
        component: FinancialAccountDetail,
        meta: {
          title: 'Detalle de cuenta financiera - Orderly.com',
        }
      },
      {
        path: 'reports/sales',
        name: 'reportsSales',
        component: ReportsSales,
        meta: {
          title: 'Reportes de negocios - Orderly.com',
        }
      },
      {
        path: 'reports/incomes',
        redirect: { name: 'reportsIncomesReceivables' },
      },
      {
        path: 'reports/incomes/receivables',
        name: 'reportsIncomesReceivables',
        component: ReportsIncomesReceivables, 
        meta: {
          title: 'Reportes de cobranza - Orderly.com',
        }
      },
      {
        path: 'reports/incomes/invoices',
        name: 'reportsSalesBilling',
        component: ReportsInvoices,
        meta: {
          title: 'Reportes de facturación - Orderly.com',
        }
      },
      {
        path: 'reports/sales/billing',
        redirect: { name: 'reportsSalesBilling' },
      },
      {
        path: 'settings/imports',
        name: 'importsHistory',
        component: ImportsHistory,
        meta: {
          title: 'Importaciones - Orderly.com',
        }
      },
      {
        path: 'settings/exports',
        name: 'exportFormats',
        component: ExportFormats,
        meta: {
          title: 'Exportación - Orderly.com',
        }
      },
    ]
  },
  {
    path: '/dominio-no-valido',
    name: 'invalidDomain',
    component: NotFound,
    meta: {
      title: 'Dominio no autorizado - Orderly',
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: NotFound,
    meta: {
      title: 'Página no encontrada - Orderly',
    }
  }
]
const router = createRouter({
  history: createWebHistory(),
  routes,
});

let domainValidationRequest = null;

const validateCurrentDomain = async () => {
  if (!domainValidationRequest) {
    domainValidationRequest = axios.get('domain/validate', {
      params: { domain: getTenantDomainFromHost(window.location.hostname) },
      skipLoading: true,
    })
      .then((payload) => payload?.type === 'success' && payload?.data?.valid === true)
      .catch(() => false);
  }

  return domainValidationRequest;
};

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) document.title = to.meta.title;

  const domainIsValid = await validateCurrentDomain();
  if (!domainIsValid && to.name !== 'invalidDomain') {
    return next({ name: 'invalidDomain' });
  }

  if (domainIsValid && to.name === 'invalidDomain') {
    return next({ name: 'login' });
  }

  const publicPaths = ['/login', '/register', '/verify-account', '/recover-password', '/new-password', '/dominio-no-valido'];
  const token = localStorage.getItem('access_token');

  if (to.name === 'notFound' || publicPaths.includes(to.path) || token) {
    if (token && isScopedAccessPatchUser() && !isRouteAllowedForScopedAccessPatch(to)) {
      return next({ name: ACCESS_PATCH_ROUTE_FALLBACK });
    }

    return next();
  }
  next('/login');
});
export default router